<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
  <div class="container container-md px-0">
    <h1 class="text-white mb-1">School Details</h1>
    <div class="mControls">
      <div class="input-group mr-auto">
        <h2 class="m-0 h3 text-white align-items-center d-inline-flex">
          <mat-icon class="me-3">school</mat-icon>{{ school?.school_name }}
        </h2>
      </div>
      <div class="mControls__right">
        <div *ngIf="loggedInUser !== tutorRoleId">
          <div class="input-group">
            <button
              mat-raised-button
              color="warn"
              (click)="deleteSchool(school)"
            >
              <mat-icon>block</mat-icon> Delete School
            </button>
          </div>
        </div>
        <div class="input-group">
          <button mat-raised-button (click)="navigateToSchoolDirectory()">
            <mat-icon>done</mat-icon> Done
          </button>
        </div>
      </div>
      <!-- tutorlogin -->
      <div *ngIf="loggedInUser === tutorRoleId" class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <ul class="list-unstyled form-lr">
                <li>
                  <span class="form-lr__left">School Id</span>
                  <span class="form-lr__right">{{ school?.uuid }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Name</span>
                  <span class="form-lr__right">{{ school?.school_name }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Street Address</span>
                  <span class="form-lr__right">{{
                    school?.school_address
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">City</span>
                  <span class="form-lr__right">{{ school?.school_city }}</span>
                </li>
                <li>
                  <span class="form-lr__left">State</span>
                  <span class="form-lr__right">{{
                    school?.state?.state_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Zip</span>
                  <span class="form-lr__right">{{ school?.school_zip }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Phone</span>
                  <span class="form-lr__right">{{ school?.school_phone }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Principal</span>
                  <span class="form-lr__right">{{
                    school?.principal_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Vice Principal</span>
                  <span class="form-lr__right">{{
                    school?.vice_principal_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">District</span>
                  <span class="form-lr__right">{{
                    school?.district?.district_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Adopted</span>
                  <span class="form-lr__right">{{
                    school?.is_adopted ? "Yes" : "No"
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Tutor Limit</span>
                  <span class="form-lr__right">{{
                    school?.association_limit
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="loggedInUser !== tutorRoleId" class="row">
        <div class="col-lg-6 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <ul class="list-unstyled form-lr">
                <li>
                  <span class="form-lr__left">School Id</span>
                  <span class="form-lr__right">{{ school?.uuid }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Name</span>
                  <span class="form-lr__right">{{ school?.school_name }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Street Address</span>
                  <span class="form-lr__right">{{
                    school?.school_address
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">City</span>
                  <span class="form-lr__right">{{ school?.school_city }}</span>
                </li>
                <li>
                  <span class="form-lr__left">State</span>
                  <span class="form-lr__right">{{
                    school?.state?.state_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Zip</span>
                  <span class="form-lr__right">{{ school?.school_zip }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Phone</span>
                  <span class="form-lr__right">{{ school?.school_phone }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Principal</span>
                  <span class="form-lr__right">{{
                    school?.principal_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Vice Principal</span>
                  <span class="form-lr__right">{{
                    school?.vice_principal_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">District</span>
                  <span class="form-lr__right">{{
                    school?.district?.district_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Adopted</span>
                  <span class="form-lr__right">{{
                    school?.is_adopted ? "Yes" : "No"
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Tutor Limit for a student</span>
                  <span class="form-lr__right">{{
                    school?.association_limit
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Tutor Limit in the school</span>
                  <span class="form-lr__right">{{
                    school?.tutor_limit
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="card mb-3">
            <div class="card-header">School Contact</div>
            <div class="card-body">
              <ul class="list-unstyled form-lr">
                <li>
                  <span class="form-lr__left">Name </span>
                  <span class="form-lr__right">{{
                    school?.clarity_person_name
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Email</span>
                  <span class="form-lr__right">{{
                    school?.clarity_person_email
                  }}</span>
                </li>
                <li>
                  <span class="form-lr__left">Phone</span>
                  <span class="form-lr__right">{{
                    school?.clarity_person_phone
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Notes</div>
            <div class="card-body">
              <p class="col-xs-12 notes-text m-0">
                {{
                  school?.notes
                    ? school.notes
                    : "This is where a
                                note could go."
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
